import { defineMessages } from 'react-intl'

import { ORDER_TYPE } from './constants'

export const orderTypeMessages = defineMessages({
  [ORDER_TYPE.SHIPMENT]: {
    id: 'spanish.orders.type.shipment',
    defaultMessage: 'Envío'
  },
  [ORDER_TYPE.PURCHASE]: {
    id: 'spanish.orders.type.purchase',
    defaultMessage: 'Compra'
  }
})
